import { useNavigate } from "react-router-dom";
import { Button } from "../components";
import styles from "./styles/productsSection.module.scss";

export const TermsAndConditionsSection = () => {
  return (
    <div className={styles.wrapper}>
      <TermsAndConditions />
    </div>
  );
};

const TermsAndConditions: React.FC<{}> = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.stateWrapper}>
        <span className={styles.title}>Terms and conditions</span>
        <div className={styles.termsAndConditionsContent}>
          <span className={styles.tncMainTitle}>Privacy Policy</span>
          <span className={styles.tncTitle}>Controller Identification</span>
          <span className={styles.tnctext}>
            This Privacy Policy outlines how NOUS medical innovations s. r. o., with registered
            office at Radlinského 1580/67, 921 01 Piešťany, Slovakia, Company ID (IČO): 55 359 639,
            collects, uses, discloses, and protects personal data in accordance with Regulation (EU)
            2016/679 of the European Parliament and of the Council of 27 April 2016 (General Data
            Protection Regulation, "GDPR").
          </span>
          <span className={styles.tncTitle}>Contact details of the controller:</span>
          <span className={styles.tnctext}>
            Email: <span>dominik.kadlubiak@appara.eu</span>
            <br />
            Website: <span>https://appara.eu/</span>
          </span>
          <span className={styles.tncTitle}>1. Purpose and Scope of Personal Data Processing</span>
          <span className={styles.tnctext}>
            We process your personal data for the following purposes:
          </span>
          <ul>
            <li>
              Preparation and fulfilment of an individual order: to contact you once your
              personalized facial mask is manufactured and ready to be shipped.
            </li>
            <li>
              Collection of delivery details: to request delivery address and related information
              necessary for shipment.
            </li>
            <li>
              Facial scan data collection: for the purpose of creating a personalized facial mask,
              where such data is voluntarily provided and processed only with the data subject’s
              explicit consent.
            </li>
            <li>
              Direct marketing (newsletter, special offers, and updates): only where the data
              subject has provided voluntary, explicit consent.
            </li>
            <li>
              This Policy applies to all individuals who voluntarily provide their data through our
              digital or physical forms, in particular during events such as Web Summit Rio 2025.
            </li>
          </ul>
          <span className={styles.tncTitle}>2. Legal Basis for Processing</span>
          <span className={styles.tnctext}>
            The processing of your personal data is based on the following legal grounds:
          </span>
          <ul>
            <li>
              <b>Article 6(1)(b) GDPR</b> – processing is necessary for the performance of a
              contract or to take steps at the request of the data subject prior to entering into a
              contract.
            </li>
            <li>
              <b>Article 6(1)(a) GDPR</b> – processing is based on the freely given, specific,
              informed and unambiguous consent of the data subject, particularly for marketing
              communications.
            </li>
            <li>
              <b>Article 9(2)(a) GDPR</b> – explicit consent of the data subject for processing
              special categories of personal data (e.g., biometric facial scan).
            </li>
          </ul>
          <span className={styles.tncTitle}>3. Categories of Personal Data Processed</span>
          <span className={styles.tnctext}>
            We collect and process only the data that is adequate, relevant, and limited to what is
            necessary in relation to the purposes described above. This may include:
          </span>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Delivery address (upon follow-up contact)</li>
            <li>
              Facial biometric data (3D facial scan), provided voluntarily for the purpose of
              producing a personalized mask
            </li>
            <li>Any additional details voluntarily provided in further communications</li>
          </ul>
          <span className={styles.tncTitle}>4. Retention Periods</span>
          <span className={styles.tnctext}>
            Personal data is retained only for as long as necessary to fulfill the purposes for
            which it was collected:
          </span>
          <ul>
            <li>
              <b>For purposes related to order fulfilment and delivery:</b> data are retained until
              the completion of delivery and any necessary follow-up support, then securely erased.
            </li>
            <li>
              <b>For marketing purposes:</b> data will be retained until the consent is withdrawn,
              or for a maximum period of 5 years from the date of consent, unless it can be
              reasonably assumed that the data subject is no longer interested.
            </li>
          </ul>
          <span className={styles.tncTitle}>5. Recipients of Personal Data</span>
          <span className={styles.tnctext}>
            We do not disclose personal data to third parties unless such disclosure is:
          </span>
          <ul>
            <li>
              Necessary for performance of the contract (e.g., delivery services or IT hosting
              providers)
            </li>
            <li>Required by law or regulatory authorities</li>
            <li>Covered by a data processing agreement in accordance with Article 28 GDPR</li>
          </ul>
          <span className={styles.tnctext}>
            All third-party processors are contractually bound to adhere to data protection
            obligations equivalent to those set out by the GDPR
          </span>
          <span className={styles.tncTitle}>6. Transfers to Third Countries</span>
          <span className={styles.tnctext}>
            As a general rule, personal data is stored and processed within the European Economic
            Area (EEA). If it becomes necessary to transfer personal data to a third country or an
            international organization, such transfer will occur only:
          </span>
          <ul>
            <li>
              To a country that has been recognized by the European Commission as providing an
              adequate level of data protection;
            </li>
            <li>
              Or with the use of standard contractual clauses or other appropriate safeguards in
              accordance with Chapter V of the GDPR.
            </li>
          </ul>
          <span className={styles.tncTitle}>7. Data Subject Rights</span>
          <span className={styles.tnctext}>
            Under the GDPR, you have the following rights regarding your personal data:
          </span>
          <ul>
            <li>
              <b>Right of access</b> (Article 15 GDPR): obtain confirmation as to whether or not
              your data are being processed, and, where that is the case, access to the data and
              related information
            </li>
            <li>
              <b>Right to rectification</b> (Article 16 GDPR): request correction of inaccurate or
              incomplete personal data.
            </li>
            <li>
              <b>Right to erasure</b> (Article 17 GDPR): request deletion of your personal data
              under certain legal grounds ("right to be forgotten").
            </li>
            <li>
              <b>Right to restriction of processing</b> (Article 18 GDPR): request that the
              processing of your data be limited in certain situations.
            </li>
            <li>
              <b>Right to data portability</b> (Article 20 GDPR): receive your personal data in a
              structured, commonly used and machine-readable format and to transmit those data to
              another controller.
            </li>
            <li>
              <b>Right to object</b> (Article 21 GDPR): object to the processing of your personal
              data where processing is based on legitimate interests or for direct marketing
              purposes.
            </li>
            <li>
              <b>Right not to be subject to automated decision-making</b> (Article 22 GDPR): you
              shall not be subject to a decision based solely on automated processing, including
              profiling, unless authorised by law.
            </li>
            <li>
              <b>Right to withdraw consent at any time</b> without affecting the lawfulness of
              processing based on consent before its withdrawal.
            </li>
            <li>
              <b>Right to lodge a complaint</b> with the Data Protection Authority of the Slovak
              Republic (www.dataprotection.gov.sk).
            </li>
          </ul>
          <span className={styles.tncTitle}>8. Contact and Complaints</span>
          <span className={styles.tnctext}>
            If you have any questions, requests or concerns regarding this Privacy Policy or the
            processing of your personal data, you may contact us at:
          </span>
          <span className={styles.tnctext}>
            NOUS medical innovations s. r. o.
            <br />
            Radlinského 1580/67, 921 01 Piešťany, Slovakia
            <br />
            Email: <span className={styles.tncLink}>dominik.kadlubiak@appara.eu</span>
            <br />
            Website: <span className={styles.tncLink}>https://appara.eu/ </span>
          </span>
          <span className={styles.tnctext}>
            If you believe that your data protection rights have been violated, you also have the
            right to file a complaint with:
          </span>
          <span className={styles.tncTitle}>
            The Office for Personal Data Protection of the Slovak Republic
          </span>
          <span className={styles.tnctext}>
            Building Park One
            <br />
            Námestie 1. mája 18, 811 06 Bratislava
            <br />
            Website:{" "}
            <span className={styles.tncLink}>https://dataprotection.gov.sk/sk/kontakt/</span>
            <br />
            Phone: +421 2 32 31 32 14
            <br />
            Email: <span className={styles.tncLink}>info@pdp.gov.sk</span>
          </span>
          <span className={styles.tncTitle}>Effective Date</span>
          <span className={styles.tnctext}>
            This Privacy Policy is effective as of 27.04.2025 and may be updated from time to time.
            Any substantial changes to this Privacy Policy will be communicated to data subjects via
            email (if provided) and published on our website.
          </span>
        </div>
        <Button text={"Back"} width={"100%"} onClick={() => navigate(-1)} />
      </div>
    </>
  );
};
